import { getTenantInfo } from "../components/user/services/Authentication";
import { setTenantConfig, setTenantStatus } from "../redux/slices/tenantConfigSlice";
import { safeParse } from "../helper/helper";
import { setUser, setLoggedIn } from "../redux/slices/userSlice";
import { setMenus } from "../redux/slices/menusSlice";

export const getTenantConfig = async ({ dispatch, setState }) => {
  // ===== 1️⃣ Read session once =====
  const hosttoken = safeParse(sessionStorage.getItem("hosttoken"));
  const tenantConfig = safeParse(sessionStorage.getItem("tenantConfig"));
  const user = safeParse(sessionStorage.getItem("user")) || null;
  const menus = safeParse(sessionStorage.getItem("menus")) || null;
  const loggedIn = safeParse(sessionStorage.getItem("loggedIn")) || null;

  // ===== 2️⃣ Hydrate app state (user / menus / loggedIn) =====
  if (user) {
    setState((prev) => ({
      ...prev,
      user,
      menus,
      loggedIn,
      tenantmenus: loggedIn?.menus || [],
    }));
  }

  if (user?.isLoggedIn) {
    dispatch(setUser({ user: user }));
  }

  if (menus) {
    dispatch(setMenus(menus));
  }

  if (loggedIn) {
    dispatch(setLoggedIn(loggedIn));
  }

  // ===== 3️⃣ If tenant already cached → STOP =====
  if (hosttoken && tenantConfig) {
    dispatch(
      setTenantConfig({
        config: tenantConfig,
        hosttoken,
        status: "ready",
      })
    );

    setState((prev) => ({
      ...prev,
      hosttoken,
      tenantConfig,
    }));

    return;
  }

  // ===== 4️⃣ Fetch tenant info =====
  try {
    setState((prev) => ({ ...prev, fullPageLoading: true }));
    dispatch(setTenantStatus("loading"));

    const response = await getTenantInfo();
    const config = response?.data?.tenantConfig;

    if (config) {
      const { hosttoken } = response.data;

      dispatch(
        setTenantConfig({
          config,
          hosttoken,
          status: "ready",
        })
      );

      setState((prev) => ({
        ...prev,
        tenantConfig: config,
        hosttoken,
      }));
    } else {
      // The API responded, but no tenant is configured for this domain
      // (e.g. status 201 / empty data). This is a genuine "tenant not found".
      dispatch(setTenantStatus("notFound"));
    }
  } catch (ex) {
    // The request failed to reach/complete (DNS, network, blocked by the
    // client, timeout, 5xx). This is NOT "tenant does not exist" — surface a
    // retryable connection error instead of a misleading tenant message.
    dispatch(setTenantStatus("error"));
  } finally {
    setState((prev) => ({ ...prev, fullPageLoading: false }));
  }
};
